
export enum YorkRecordType  {           
        Monument = "mon",     
        Event = "event", 
        EventIntrusive = "event_intrusive", 
        EventNonIntrusive = "event_nonintrusive", 
        EventDepositModel = "event_depositmodel", 
        Source = "source",
        Designation= "desig"
}  

export enum YorkRecordSubType  {   
    ConservationArea = "COA",
    ListedBuilding = "LB",
    RegisteredParkAndGarden = "RG",
    ScheduledMonument = "SAM",  
    AreasArchaeologicalImportance = "AAI"
}  
